export function match(value) {
  return (/^[0-9]+$/u).test(value)
}
